import { render, staticRenderFns } from "./CoverageDetails.vue?vue&type=template&id=2b1bc856"
import script from "./CoverageDetails.vue?vue&type=script&lang=js"
export * from "./CoverageDetails.vue?vue&type=script&lang=js"
import style0 from "./CoverageDetails.vue?vue&type=style&index=0&id=2b1bc856&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports